import { imagePath } from "../../../../utils/imagePath"

const MrTecnologyData =  {
    slug: 'concepts/mr',
    sectionTitle: 'MR Technology',
    blocks: [
      {
        type: 'text',
        content: [
          'Mixed Reality (MR) combines the best of Augmented Reality and Virtual Reality to create experiences where digital content and the physical world interact seamlessly. In MR, virtual objects don’t just appear in your environment—they understand it, respond to it, and interact with it.',
          'MR enables users to see and interact with digital elements as if they truly exist in the real world, while still allowing immersive virtual content when needed.',
        ],
      },
      {
        type: 'image',
        src: imagePath?.MRTecnology,
        alt: 'Dashboard',
      },
    ],
    subSections: [
      {
        title: '3.1  How Mixed Reality Works',
        blocks: [
          {
            type: 'text',
            content: [
              'Mixed Reality uses advanced spatial computing to understand both the **user** and the **environment:**',
            ],
          },
          {
            type: 'list',
            style: 'disc',
            items: [
              'Cameras and sensors scan the physical space',
              'The system maps surfaces, depth, and spatial relationships',
              'Digital objects are placed with real-world awareness',
              'Virtual elements interact with physical objects in real time',
            ],
          },
          {
            type: 'text',
            content: [
              'This allows digital content to remain stable, realistic, and responsive as users move and interact.',
            ],
          },
        ],
      },
      {
        title: '3.2 What Makes MR Unique',
        blocks: [
          {
            type: 'text',
            content: [
              'MR goes beyond overlaying content or full immersion by:',
            ],
          },
          {
            type: 'list',
            style: 'disc',
            items: [
              'Allowing **digital objects to interact with physical surroundings**',
              'Enabling **natural interactions** using hands, gestures, or controllers',
              'Supporting **context-aware experiences** that adapt to real environments',
              'Blending real and virtual elements into a single, continuous experience',
            ],
          },
          {
            type: 'text',
            content: ['This creates a deeper sense of realism and presence.'],
          },
        ],
      },
      {
        title: '3.3 What You Can Build with MR',
        blocks: [
          {
            type: 'text',
            content:
              'Mixed Reality supports advanced spatial experiences such as:',
          },
          {
            type: 'list',
            style: 'disc',
            items: [
              '**Interactive training simulations** in real environments',
              '**Complex equipment visualization** with real-world context',
              '**Collaborative design reviews** blending physical and digital models',
              '**Immersive learning environments** with hands-on interaction',
              'Operational guidance and simulations',
            ],
          },
          {
            type: 'text',
            content:
              'MR is especially powerful where **precision, interaction, and realism** are required.',
          },
        ],
      },
    ],
}
  export default MrTecnologyData